import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1037"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m5.857 9.48 2.906-4.37-1.85-3.78a.203.203 0 0 0-.367.006L.145 13.726a.202.202 0 0 0 .182.292l4.508-.013 1.69-3.142-.668-1.383zm9.969 3.219-2.011-4.204-4.739 4.467 6.566.028c.15 0 .248-.156.184-.291z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m11.288 7.096 1.182-4.429-5.232 6.296 1.619.047-2.621 4.874 6.755-6.366z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }